import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseInfoIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="none"
        height="14"
        viewBox="0 0 330 330"
        width="14"
    >
        <path
            d="M165 0C74.019 0 0 74.02 0 165.001C0 255.982 74.019 330 165 330C255.981 330 330 255.982 330 165.001C330 74.02 255.981 0 165 0ZM165 300C90.56 300 30 239.44 30 165.001C30 90.562 90.56 30 165 30C239.44 30 300 90.562 300 165.001C300 239.44 239.439 300 165 300Z"
            fill="#333333"
        />
        <path
            d="M164.998 70C153.972 70 145.002 78.976 145.002 90.009C145.002 101.032 153.972 110 164.998 110C176.024 110 184.994 101.032 184.994 90.009C184.994 78.976 176.024 70 164.998 70Z"
            fill="#333333"
        />
        <path
            d="M165 140C156.716 140 150 146.716 150 155V245C150 253.284 156.716 260 165 260C173.284 260 180 253.284 180 245V155C180 146.716 173.284 140 165 140Z"
            fill="#333333"
        />
    </svg>
);

export const InfoIcon = styled(BaseInfoIcon)``;
